import { render, staticRenderFns } from "./TextColorEditor.vue?vue&type=template&id=70d6d10c&scoped=true"
import script from "./TextColorEditor.vue?vue&type=script&lang=js"
export * from "./TextColorEditor.vue?vue&type=script&lang=js"
import style0 from "./TextColorEditor.vue?vue&type=style&index=0&id=70d6d10c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d6d10c",
  null
  
)

export default component.exports